import React from "react";
import styled from "styled-components";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const ModalBox = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 2rem;
  width: 400px;
  max-width: 90%;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
`;

const Title = styled.h2`
  font-size: 22px;
  color: #2d3436;
  margin-bottom: 1rem;
`;

const RoleBlock = styled.div`
  margin-bottom: 1rem;
`;

const RoleTitle = styled.p`
  font-weight: 600;
  font-size: 1rem;
  color: #212529;
  margin-bottom: 0.25rem;
`;

const RoleDescription = styled.p`
  color: #495057;
  font-size: 0.9rem;
  margin: 0;
`;

const CloseButton = styled.button`
  margin-top: 1rem;
  padding: 0.5rem 1.5rem;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    background: #218838;
  }
`;

const Footer = styled.div`
display : flex;
justify-content : end;
`

const ExpenseRolesModal = ({ isOpen, onClose }:any) => {
  if (!isOpen) return null;

  return (
    <Overlay onClick={onClose}>
      <ModalBox>
        <Title>Expenses Roles</Title>


        <RoleBlock>
          <RoleTitle>Admin</RoleTitle>
          <RoleDescription>
            Manage all Expenses settings.
          </RoleDescription>
        </RoleBlock>

        <RoleBlock>
          <RoleTitle>Submitter</RoleTitle>
          <RoleDescription>Can submit claims and view his own expenses.</RoleDescription>
        </RoleBlock>

        <RoleBlock>
          <RoleTitle>Approver</RoleTitle>
          <RoleDescription>
            The approver submits and approves others' expenses.
          </RoleDescription>
        </RoleBlock>

        <Footer>
            <CloseButton onClick={onClose}>Close</CloseButton>
        </Footer>
      </ModalBox>
    </Overlay>
  );
};

export default ExpenseRolesModal;
